import { DrawFence } from '../fence/DrawFence';
import { SC_Input } from '../input/SC_Input';
import { Global } from "../utilities/global";
export function clearDataOnExit () {
    Global.dragDropModules = {
        rows: 1,
        columns: 1,
        portrait: true,
        allowPanelonRoof: false
    }
    Global.panelRows = [];
    DrawFence.FenceCount == 0;
    Global.iRoofShape = null;
    Global.roofObstructions = [];
    if (SC_Input.sPlanDetails && SC_Input.sPlanDetails.panelRows) {
        SC_Input.sPlanDetails.panelRows = [];
      } 
      if (SC_Input.sPlanDetails && SC_Input.sPlanDetails.roofObstructions) {
        SC_Input.sPlanDetails.roofObstructions = [];
      }   
}